/* src/app/job-signoff-shredder/pages/job-signoff-shredder-view/job-signoff-shredder-view.component.scss */
/*# sourceMappingURL=job-signoff-shredder-view.component.css.map */
